import { CSSObject } from '@emotion/serialize';

export const closeDialogButton = (theme: any): CSSObject => ({
  position: 'absolute',
  top: theme.spacing(2),
  right: theme.spacing(2),
});
